

import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import Vuex from 'vuex'
import store from '../static/sotre/index'
import fastclick from 'fastclick'
import components from '../static/plugins/components' 
import http from '../http'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import auth  from './utils/auth.js';
import apiLog  from './utils/logon.js';
import authWX  from './utils/authWX.js';
import apiLogWX  from './utils/logonWX.js';
import mobileDetect from './utils/mobile-detect.js'

Vue.prototype.$auth = auth;
Vue.prototype.$apiLog = apiLog;
Vue.prototype.$authWX = authWX;
Vue.prototype.$apiLogWX = apiLogWX;
Vue.prototype.$mobileDetect= mobileDetect


import AlertPlugin from 'vux/src/plugins/alert/index.js'

import axios from 'axios'
Vue.config.productionTip = false

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import AmapVue from '@amap/amap-vue' 
AmapVue.config.key = '54f1cb991891fb7741a7bca2196221c0'
Vue.use(AmapVue)

Vue.use(Viewer);
Viewer.setDefaults({
Options: {
"inline": true,
"button": true,
"navbar": true,
"title": true,
"toolbar": true,
"tooltip": true,
"movable": true,
"zoomable": true,
"rotatable": true,
"scalable": true,
"transition": true,
"fullscreen": true,
"keyboard": true,
"url": "data-source"
}
});

Vue.prototype.mk = "01AT456RE9ABCSER"
Vue.prototype.py = "0123489789101785"
Vue.prototype.pyl = "abcd123!@#abcd12"


import {
Notify,
Sidebar,
SidebarItem,
Search,
Icon,
DropdownMenu,
DropdownItem,
Button,
Rate,
Form,
Field,
Tab,
Tabs,
Step,
Steps,
ActionSheet,
Toast,
Popup,
Picker,
RadioGroup,
Radio,
Checkbox,
CheckboxGroup,
DatetimePicker,
TreeSelect,
SwipeCell,
Cell,
Empty,
List,
Dialog,
Loading,
Swipe,
SwipeItem,
Lazyload,
Uploader,
Calendar,
Overlay,
Col,
Row,
Tag,
Collapse,
CollapseItem,
PullRefresh,
} from 'vant';
Vue.use(Sidebar).use(SidebarItem).use(Search).use(Icon).use(DropdownMenu).use(DropdownItem).use(Button).use(Rate).use(
Form).use(Field).use(Tab).use(Tabs).use(Step).use(Steps).use(ActionSheet).use(Toast).use(Popup).use(Picker).use(
RadioGroup).use(Radio).use(Checkbox).use(CheckboxGroup).use(DatetimePicker).use(TreeSelect).use(SwipeCell).use(
Cell).use(Empty).use(List).use(Dialog).use(Loading).use(Swipe).use(SwipeItem).use(Lazyload).use(Uploader).use(
Calendar).use(Overlay).use(DropdownMenu).use(DropdownItem).use(Notify).use(Col).use(Row).use(Tag).use(Collapse).use(CollapseItem).use(PullRefresh);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(Vuex)
Vue.use(preview)
Vue.use(components)
Vue.use(AlertPlugin)
Vue.prototype.$http = http;
Vue.prototype.$axios = axios
fastclick.attach(document.body)


import moment from 'moment'
Vue.prototype.moment = moment;

import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)


import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)





Vue.prototype.$axios = axios

Vue.prototype.api = process.env.NODE_ENV === 'production' ?
'https://weixin.njrsrc.cn/wxportal/nwservice/CMP/BaseServer' :
'https://weixin.njrsrc.cn/wxportal/nwservice/CMP/BaseServer'




Vue.prototype.ThsgetCode = async function() {
store.state.status.codeImg = null;
store.state.status.codeId = null;



let params = {
'method': 'YZM_Creat'
}
let res = await http.get('http://weixin.njrsrc.cn/CMP/BaseServer', params);
store.state.status.codeImg = res.data.result.result.data[0].YZM64;
store.state.status.codeId = res.data.result.result.data[0].YZMcode;
}
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js